import { isOverDueDate, isUrgentDate } from "@/shared/utils";
import type { NotesTableRowData } from "../../model/types/notes-table-types";

export const getRowTextColor = (
  record: NotesTableRowData,
  isColorize?: boolean,
): "#F3655E" | "#D47F08" | "" => {
  if (!isColorize) return "";
  if (isOverDueDate({ dueDate: record.dueDate })) {
    return "#F3655E";
  }
  if (isUrgentDate({ dueDate: record.dueDate })) {
    return "#D47F08";
  }
  return "";
};
